import React from 'react';
import { MapPin, Calendar, CreditCard, Car } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      icon: <MapPin className="h-6 w-6" />,
      title: 'Enter Your Route',
      description: 'Pick your airport, destination and travel date',
    },
    {
      number: '02',
      icon: <Calendar className="h-6 w-6" />,
      title: 'Get Instant Price',
      description: 'See your fixed price with no hidden charges',
    },
    {
      number: '03',
      icon: <CreditCard className="h-6 w-6" />,
      title: 'Pay Securely',
      description: 'Use PayPal, Stripe or card - your choice',
    },
    {
      number: '04',
      icon: <Car className="h-6 w-6" />,
      title: 'Enjoy Your Ride',
      description: 'Meet your driver and travel in comfort',
    },
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            How It Works
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Book your premium transfer in 4 simple steps
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Road Lane Connector (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 -translate-y-1/2 h-0.5 bg-border">
            <div className="road-lane-pattern opacity-30"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
            {steps.map((step, index) => (
              <div
                key={index}
                className="relative flex flex-col items-center text-center group"
              >
                {/* Step Number */}
                <div className="relative z-10 mb-6">
                  <div className="w-20 h-20 rounded-2xl bg-secondary border border-border flex items-center justify-center group-hover:bg-primary group-hover:border-primary transition-all duration-300">
                    <span className="font-display text-2xl font-bold text-muted-foreground group-hover:text-primary-foreground transition-colors duration-300">
                      {step.number}
                    </span>
                  </div>
                  {/* Icon Badge */}
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 rounded-lg bg-primary flex items-center justify-center text-primary-foreground shadow-orange-glow">
                    {step.icon}
                  </div>
                </div>

                <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {step.description}
                </p>

                {/* Mobile Connector */}
                {index < steps.length - 1 && (
                  <div className="md:hidden w-px h-8 bg-border my-4">
                    <div className="w-1 h-full mx-auto bg-primary/30"></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;